import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "recompose";
import {
  formatDate,
  getMainCategory,
} from "../../../services/helpers/articles";

import Section from "../../blocks/Section/Section";
import { Article } from "../Article/Article";
import { getListOfArticles } from "../../../services/redux/articles/widget/reducer";
import useCategories from "../../categories/useCategories";
import "./Sections.scss";

const NewsSection = ({
  articles,
  fetchArticlesAll,
  articlesTags,
  t,
  allowedCategories,
  categoriesList,
  subtitle,
}) => {
  const [activeCategory, setActiveCategory] = useState(null)
  
  const { categories } = useCategories();
  useEffect(() => {
    fetchArticlesAll({
      limit: 6,
      categories_list: categoriesList,
      ordering: "-published_at",
    });
  }, []);

  const articlesCategories = allowedCategories
    ? categories.filter(({ id }) => allowedCategories.indexOf(id) !== -1)
    : categories;

  return (
    <Section
      title={
        <>
          <h2>
            {t("widgets:news.title")}
            {/* {subtitle && <small>{subtitle}</small>} */}
          </h2>
          
        </>
      }
      subtitle=''
      allCategoriesLinkAnchor='Wszystkie artykuły'
    >
        <div className="Sections__articles Sections__articles--flex">
          {articles.map(
            ({
              id,
              thumb,
              published_at,
              tags,
              summary,
              name,
              content,
              slug,
              video_url,
              categories,
              access,
            }) => (
              <Article
                key={id}
                id={id}
                className="sideArticle sideArticle--solid"
                src={thumb !== null ? thumb.file : ""}
                date={formatDate(published_at)}
                tags={tags}
                category={getMainCategory(categories)}
                summary={summary}
                articleTitle={name}
                articleText={content}
                articlesTags={articlesTags}
                slug={slug}
                video={!!video_url}
                access={access}
                isHomepage
              />
            )
          )}
        </div>
    </Section>
  );
};

NewsSection.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.any),
};

NewsSection.defaultProps = {
  articles: [],
};

export default compose(
  withTranslation(["widgets", "urlsNames"]),
  connect(
    state => ({
      articles: state.articles.articlesAll.results.slice(0, 6),
      articlesTags: state.articles.articlesTags.results,
    }),
    dispatch => ({
      fetchArticlesAll: config => dispatch(getListOfArticles(config)),
    })
  )
)(NewsSection);
